
  export default {
    props: {
      flat: {
        default: false,
      },
      selected: {
        default: false,
      },
    },
  };
  